import { LocalStorage } from 'src/@types/LocalStorage'

export const useTrustedDeviceId = () => {
  const trustedDeviceReferenceId = localStorage.getItem(LocalStorage.TrustedDeviceId)
    ? JSON.parse(localStorage.getItem(LocalStorage.TrustedDeviceId))
    : ''

  return trustedDeviceReferenceId
}
